<template lang="">
   <!-- <ProductDetailsHeader/> -->
   <div class="thankcover " >
    <div class="border-1 b2b_product d-flex align-items-center flex-wrap justify-content-between" >
      <div class="d-flex align-items-center gap-1">
        <img :src="selectedPlanData.supportingData.insCompanyLogo" class="product_logo" alt="" width="120" height="auto">
        <p class="mb-0 insurer_name">{{selectedPlanData.insuranceAndProducts.insuranceCompanyName}}</p>
      </div>
      <div>
        <p class=" p-2 mb-0 ">
          <!-- <span>JOURNEY ID:&nbsp;</span>
          <strong class="">{{this.journeyId}}</strong>
          <div class="copy_container">
            <img src="@/assets/images/copy-icon.svg" class="copy-icon " @click="copyToClipboard" v-if="!copySuccess"/>
            <img src="@/assets/images/accept.png" class="copy-icon-tick m-0 p-0" v-if="copySuccess" />
            <p class="copy_tooltip px-2 py-1 rounded">{{ !copySuccess ? 'Copy' : 'Copied' }}</p>
          </div> -->

          <div class="copy_CID mb-2">
            <JourneyIdContainer :journey-id="journeyId" label="JOURNEY ID :" />
          </div>

          <!-- <img src="@/assets/images/copy-icon.svg" width="20" height="20" class="copy-icon m-auto" @click="copyToClipboard" v-if="!copySuccess"/>
          <img src="@/assets/images/accept.png" width="20" height="20" class="copy-icon-tick m-0 p-0" v-if="copySuccess" /> -->
        </p>
      </div>
    </div>
       <div class="thank-you mt-4">
      <div class="text-center">
        <div class="moving_background">
          <div class="road"></div>
          <div class="trees-container">
            <div class="tree tree1"></div>
            <div class="tree tree2"></div>
            <div class="tree tree3"></div>
            <div class="tree tree4"></div>
            <div class="tree tree5"></div>
          </div>
          <div class="clouds-container">
            <div class="cloud cloud1"></div>
            <div class="cloud cloud2"></div>
            <div class="cloud cloud3"></div>
          </div>
          <img src="@/assets/images/bikeinsurance.png" draggable='false' class="bike-image m-auto mb-3" v-if="vehicleType == 'bike'"/>
          <div class="car-container" v-if="vehicleType == 'car'">
            <img src="@/assets/images/b2b-car.png" draggable='false' class="car-image m-auto mb-3"/>
            <!-- <img src="@/assets/images/wheel.png" draggable='false' class="wheel wheel-1 m-auto mb-3"/>
            <img src="@/assets/images/wheel.png" draggable='false' class="wheel wheel-2 m-auto mb-3"/> -->
          </div>
        </div>
        <h4 v-if="tempSetting.Email && tempSetting.Sms" class=" text-center">An email has been sent successfully to the  customer's registered <br/> 
            email Id  <span class="customer_email">{{obfuscateEmail(email)}}</span> and  SMS on mobile number <span class="customer_mobile">{{obfuscatePhoneNumber(mobileno)}}</span></h4>

        <h4 v-if="tempSetting.Email && !tempSetting.Sms" class=" text-center">An email has been sent successfully to the  customer's registered <br/> 
          email Id  {{obfuscateEmail(email)}}.</h4>

        <h4 v-if="!tempSetting.Email && tempSetting.Sms" class=" text-center">
          An SMS has been sent successfully to the customer's registered Mobile number {{obfuscatePhoneNumber(mobileno)}}</h4>
        <p class="text-center">Customer has to review and submit  the proposal along with  making a payment.</p>
      </div>
    </div> 
   </div>
  </template>
  <script>
import { email } from '@vuelidate/validators';
import ProductDetailsHeader from '../productDetailsHeader/ProductDetailsHeader.vue';
import { getTemplateSetting } from '@/mixins/common';
  export default {
    mixins: [getTemplateSetting],
    components:{
      ProductDetailsHeader,
    },
  data(){
    return{
      mobileno:'',
      email:'',
      user_profile:{},
      tempSetting: {},
      selectedPlanData: sessionStorage.getItem("selected_plan_data") && JSON.parse(sessionStorage.getItem("selected_plan_data")),
      paymentPollingStatus: sessionStorage.getItem("payment_poll_status") && JSON.parse(sessionStorage.getItem("payment_poll_status")),
      applicationNumber: "",
      journeyId: "",
      vehicleType: ""
    }
  },
  mounted(){
      this.tempSetting = getTemplateSetting();
      this.user_profile=JSON.parse(sessionStorage.getItem("filledData"));
      this.email=this.user_profile.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input
      this.mobileno=this.user_profile.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.input;
      if(sessionStorage.getItem("applicationNumber") && sessionStorage.getItem("applicationNumber") != '') {
        this.applicationNumber = JSON.parse(sessionStorage.getItem("applicationNumber"));
      }
      if(sessionStorage.getItem("journey_id")){
        this.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
      }
      let motorProductType = this.$store.state.motorProductType;
      this.vehicleType = motorProductType.includes('2W') ? 'bike' : 'car';
  },
  methods:{
    obfuscateEmail(email) {
      if(!email){
        return;
      }
      const [username, domain] = email.split('@');
    const domainParts = domain.split('.');
    
    if (username.length <= 3) {
        return `${username[0]}***@${domain}`;
    }

    const visibleChars = 2; // Number of visible characters from the start of the username
    const obfuscatedUsername = username.slice(0, visibleChars) + '*'.repeat(username.length - visibleChars);
    
    return `${obfuscatedUsername}@${domain}`;
},
    obfuscatePhoneNumber(phoneNumber) {
      if (!phoneNumber) return phoneNumber;

      // Convert to string
      const phoneStr = String(phoneNumber);

      if (phoneStr.length < 5) {
        return phoneStr; // Return as-is if too short
      }

      const firstTwo = phoneStr.slice(0, 2);
      const lastThree = phoneStr.slice(-3);
      const middleLength = phoneStr.length - 5;
      const obfuscatedMiddle = '*'.repeat(middleLength);

      return `${firstTwo}${obfuscatedMiddle}${lastThree}`;
    }
  }
  };
  </script>
  <style lang="scss">
 @import "../../assets/scss/components/Loaders.scss";

.copy-journey{
  display: flex;
  align-items: center;
  strong{
    color: $main-bg;
    margin-right: 12px !important;
  }
  span{
    color: $main-bg;
  }
}
.customer_mobile,
.customer_email{
  color: $main-bg !important;
}
.dark .copy-icon{
  filter: invert(1);
}
.dark{
  .customer_mobile,
  .customer_email{
    color: $main-bg !important;
  }
}
.copy_container{
  position: relative;
  img{
    width: 20px !important;
    border: none;
  }
  .copy-icon{
    transform: scale(1.5);
    height: 16px !important;
  }
  .copy-icon-tick{
    transform: scale(1);
    margin-left: auto !important;
  }
  .copy_tooltip{
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: -32px;
    left: -20px;
    font-size: 14px;
    color: $commonColor;
    background-color: $cardBackgroundDark;
  }
  &:hover{
    .copy_tooltip{
      visibility: visible;
      opacity: 1;
    }
  }
}
 .moving_background {
   position: relative;
   height: 210px;
   width: 100%;
   margin: 0 auto 20px;
   overflow: hidden;
   
   .bike-image {
     width: 250px;
     position: relative;
     z-index: 5;
     margin-top: 50px;
     animation: jump 0.5s ease-in-out infinite alternate;
   }
   .car-container{
    position: relative;
    .car-image{
      width: 400px;
      height: auto;
      padding-top: 50px;
      position: relative;
      z-index: 5;
      margin-top: 50px;
      animation: jump 0.5s ease-in-out infinite alternate;
    }
    .wheel{
      position: absolute;
      width: 65px;
      height: auto;
    }
    .wheel-1{
      top: 61%;
      left: 57.7%;
      transform: translate(50%, 50%);
      z-index: 100;
      animation: rotate 0.5s linear infinite;
    }
    .wheel-2{
      top: 61%;
      left: 38%;
      transform: translate(50%, 50%);
      z-index: 100;
      animation: rotate 0.5s linear infinite;
    }
   }
  @keyframes jump {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-5px);
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
   
   .road {
     position: absolute;
     bottom: 0;
     width: 100%;
     height: 50px;
     background: linear-gradient(to right, #888, #666, #888);
     animation: roadMove 3s linear infinite;
     z-index: 1;
     
     &::after {
       content: '';
       position: absolute;
       left: 0;
       top: 50%;
       width: 100%;
       height: 4px;
       background: repeating-linear-gradient(to right, white, white 30px, transparent 30px, transparent 60px);
       animation: lineMove 1s linear infinite;
     }
   }
   
   .trees-container {
     position: absolute;
     bottom: 50px;
     width: 100%;
     height: 120px;
     z-index: 2;
     
     .tree {
       position: absolute;
       bottom: 0;
       width: 20px;
       height: 80px;
       animation: treeMove 8s linear infinite;
       
       &::before {
         content: '';
         position: absolute;
         bottom: 0;
         left: 50%;
         transform: translateX(-50%);
         width: 6px;
         height: 30px;
         background: #5d4037;
       }
       
       &::after {
         content: '';
         position: absolute;
         bottom: 30px;
         left: 50%;
         transform: translateX(-50%);
         width: 30px;
         height: 50px;
         background: #2e7d32;
         border-radius: 50% 50% 30% 30%;
       }
     }
     
     .tree1 {
       right: -50px;
       height: 100px;
       animation-delay: 0s;
     }
     
     .tree2 {
       right: -150px;
       height: 70px;
       animation-delay: 2s;
     }
     
     .tree3 {
       right: -250px;
       height: 90px;
       animation-delay: 4s;
     }
     
     .tree4 {
       right: -350px;
       height: 80px;
       animation-delay: 6s;
     }
     
     .tree5 {
       right: -450px;
       height: 110px;
       animation-delay: 8s;
     }
   }
   
   .clouds-container {
     position: absolute;
     top: 0;
     width: 100%;
     height: 60px;
     z-index: 3;
     
     .cloud {
       position: absolute;
       width: 60px;
       height: 25px;
       background: #fff;
       border-radius: 50px;
       animation: cloudMove 15s linear infinite;
       
       &::before, &::after {
         content: '';
         position: absolute;
         background: #fff;
         border-radius: 50%;
       }
       
       &::before {
         width: 30px;
         height: 30px;
         top: -15px;
         left: 10px;
       }
       
       &::after {
         width: 20px;
         height: 20px;
         top: -10px;
         right: 10px;
       }
     }
     
     .cloud1 {
       top: 10px;
       right: -100px;
       animation-delay: 0s;
     }
     
     .cloud2 {
       top: 30px;
       right: -250px;
       animation-delay: 5s;
     }
     
     .cloud3 {
       top: 5px;
       right: -400px;
       animation-delay: 10s;
     }
   }
 }

 @keyframes roadMove {
   0% {
     background-position: 0 0;
   }
   100% {
     background-position: 60px 0;
   }
 }
 
 @keyframes lineMove {
   0% {
     background-position: 120px 0;
   }
   100% {
     background-position: 0 0;
   }
 }
 
 @keyframes treeMove {
   0% {
     transform: translateX(0);
   }
   100% {
     transform: translateX(-1000px);
   }
 }
 
 @keyframes cloudMove {
   0% {
     transform: translateX(0);
   }
   100% {
     transform: translateX(-1000px);
   }
 }
  </style>
  